import { BiRightArrowAlt } from 'react-icons/bi';
import Button from '../../../../components/atoms/Button';
import { ActionsBar, LinkButton, ActionsSpacer } from './actionsStyles';

/**
 * Ações do onboarding dentro do modal (mock Caio — sem footer fixo inferior).
 */
export default function OnboardingActions({
  onBack,
  onSkip,
  onContinue,
  continueLabel,
  backLabel,
  skipLabel,
  continueDisabled = false,
  loading = false,
  showContinueArrow = true,
}) {
  return (
    <ActionsBar data-testid="onboarding-actions">
      <ActionsSpacer>
        {!!onBack && (
          <LinkButton type="button" onClick={onBack} disabled={loading} data-testid="action-back">
            {backLabel}
          </LinkButton>
        )}
        {!!onSkip && (
          <LinkButton type="button" onClick={onSkip} disabled={loading} data-testid="action-skip">
            {skipLabel}
          </LinkButton>
        )}
      </ActionsSpacer>
      {!!onContinue && (
        <Button
          disabled={continueDisabled || loading}
          onClick={onContinue}
          endIcon={showContinueArrow ? <BiRightArrowAlt /> : undefined}
          data-testid="action-continue"
        >
          {continueLabel}
        </Button>
      )}
    </ActionsBar>
  );
}
